import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validate } from "components/DynamicForm/validate";
import DynamicForm from "components/DynamicForm";
import FormButton from "components/FormButton";
import GuardianRecursiveDataPreview from "components/GuardianRecursiveDataPreview";
import { Label } from "lib";
import { dynamicFormScroll, dynamicFormScrollBottom } from "utils";
import {
  clearRecursiveFormData,
  clearSaveData,
  clearShowData,
  setFormFields,
  clearRecursiveFormDataKey,
  setEditIndex,
  setEditSaveData,
  setEditShowData,
  setIsEditRecursiveForm,
  setRecursiveFormData,
  setSaveData,
  setShowAddMore,
  setShowData,
  setShowDataPreview,
  setShowRecursiveForm,
  setMaxLength,
  setMinLength,
  setArrayName,
  setSignerParams,
  etAssociatedWf,
  setIsMinorDisabled,
  setIsAssociatedWfDisabled,
  setAssociatedWfAge,
  setAssociateRequired,
  setCurrentFormType,
  cleardeleteRecursiveDocument,
  setGuardianKey,
  setGuardianLabel,
  setMaxGuardianLimit,
} from "redux/guardianReducer";
import { setSelectedData as setSelectedFormData } from "redux/formDisplay";
// import { setAssociateRequired , setCurrentFormType } from 'redux/recursiveReducer';
import 'react-toastify/dist/ReactToastify.css';

import "./index.scss";
import { clearValidateTriggered } from "redux/formDisplay";
import { setdeleteDocument } from "redux/uploadDocumentReducer";
import { Row } from "react-bootstrap";
import { setSubworkFlowInfo } from "redux/dashBoardDetailReducer";
import { getDependentsId, getDependentsNames, getGuardiansId } from "helper";
import { ToastContainer } from "react-toastify";

const GuardianRecursive = (props) => {
  const {
    recursiveRead,
    recursiveTrigger,
    recursiveName,
    dataPreview,
    setSelectedData,
    selectedData,
    inputFields,
    recursiveActions,
    handleNext,
    handleAdd,
    handleCancel,
    recursiveTitle,
    handleBack,
    formErr,
    setFormErr,
    clearFieldError,
    minLength,
    maxLength,
    SignerRecursion,
    triggerEsignRequest,
    signaturePosition,
    signer_validation_name,
    guardianKey,
    guardianLabel,
    maxGuardianLimit
  } = props;

  const dispatch = useDispatch();

  const guardianRecursive = useSelector((state) => state.guardianRecursive);
  const formData = useSelector((state) => state.formData);
  const saveData = useSelector((state) => state.guardianRecursive.saveData);
  const showData = useSelector((state) => state.guardianRecursive.showData);
  const formFields = useSelector((state) => state.guardianRecursive.formFields);
  const staticData = useSelector((state) => state?.staticData);
  const recursiveFormData = useSelector(
    (state) => state.guardianRecursive?.recursiveFormData
  );
  const isEditRecursiveForm = useSelector(
    (state) => state.guardianRecursive?.isEditRecursiveForm
  );
  const deleteRecursiveDocument = useSelector(
    (state) => state.guardianRecursive?.deleteRecursiveDocument
  );
  const showRecursiveForm = useSelector(
    (state) => state.guardianRecursive.showRecursiveForm
  );
  const showDataPreview = useSelector(
    (state) => state?.guardianRecursive?.showDataPreview
  );
  const selectedFormData = useSelector((state) => state.formData?.selectedData);
  let complete_selectedData = useSelector(
    (state) => state.formData?.selectedData
  );
  const subworkFlowInfo = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  );
  const currentFormType = useSelector(
    (state) => state?.guardianRecursive?.currentFormType
  );
  const editIndex = useSelector((state) => state.guardianRecursive.editIndex);
  //rework
  const associateRequired = useSelector(
    (state) => state?.guardianRecursive?.associateRequired
  );
  //Mobile Responsivess state
  const [isMobile, setIsMobile] = useState(false);

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  // useEffect(() => {
  //   if (currentFormType === "applicant" && selectedData?.majority == "Minor") {
  //     dispatch(setAssociateRequired());
  //   } else {
  //     dispatch(setAssociateRequired());
  //   }
  // }, [selectedData?.birth_date, isEditRecursiveForm]);

  const handleAddMore = (currentUser) => {
    if (currentUser) dispatch(setCurrentFormType(currentUser));
    else dispatch(setCurrentFormType("applicant"));
    //Removing the previously filled data to get a clean form (moved code to handleAdd)
    let recursiveNameFields = [];
    formFields.map((item) => {
      return recursiveNameFields.push({ name: item.name, label: item.label });
    });
    if (SignerRecursion == true) {
      dispatch(clearRecursiveFormDataKey({ key: "trigger_esign_request" }));
      dispatch(clearRecursiveFormDataKey({ key: "signature_position" }));
      dispatch(clearRecursiveFormDataKey({ key: "co_signer" }));
      dispatch(clearRecursiveFormDataKey({ key: "signer_validation_name" }));
    }
    if (recursiveFormData?.hasOwnProperty("verification_response")) {
      dispatch(clearRecursiveFormDataKey({ key: "verification_response" }));
    }
    recursiveNameFields.map((item) => {
      dispatch(clearRecursiveFormDataKey({ key: item.name }));
    });
    dispatch(clearValidateTriggered());
    dispatch(setShowRecursiveForm(true));
    dispatch(setShowAddMore(false));
    dynamicFormScrollBottom();
  };

  // fired when edit button is clicked in dataPreview
  const handleEditChange = (index) => {
    Object.entries(saveData[index]).map((item) => {
      dispatch(setRecursiveFormData({ key: item[0], value: item[1] }));
    });
    dispatch(setEditIndex(index));
    dispatch(setShowAddMore(false));
    dispatch(setIsEditRecursiveForm(true));
    dispatch(setShowRecursiveForm(true));
    dispatch(clearValidateTriggered()); // To clear the validation error when the user clicks on back button or page refresh or next button
    setFormErr({});
    dynamicFormScrollBottom();
  };

  //* called on click of update button
  const handleEdit = async() => {
    if (
      complete_selectedData &&
      Object.entries(complete_selectedData)?.length == 0 &&
      Object.entries(subworkFlowInfo)?.length > 0
    ) {
      complete_selectedData = subworkFlowInfo?.source_data;
    }
    let validateFields = [];
    inputFields.map((_item) => {
      if (_item.hasOwnProperty("show") && IndirectEval(_item.show)) {
        validateFields = [...validateFields, _item];
      }
    });
    let errors;
    errors = await validate(
      validateFields,
      recursiveFormData,
      dispatch,
      staticData,
      null,
      guardianRecursive,
      complete_selectedData
    );
    let errKeys = Object.keys(errors);
    if (errKeys?.length !== 0) {
      setFormErr(errors);
      dynamicFormScroll();
      return;
    }
    let editRecursiveData = {};
    formFields.map((item) => {
      if (recursiveFormData[item.name] && IndirectEval(item?.show)) {
        editRecursiveData[item.name] = recursiveFormData[item.name];
      }
      if (recursiveFormData?.hasOwnProperty("verification_response")) {
        editRecursiveData["verification_response"] =
          recursiveFormData["verification_response"];
        dispatch(clearRecursiveFormDataKey({ key: "verification_response" }));
      }
    });
    if (SignerRecursion == true && signaturePosition && triggerEsignRequest) {
      editRecursiveData["signature_position"] = signaturePosition;
      editRecursiveData["trigger_esign_request"] =
        IndirectEval(triggerEsignRequest);
    }
    if (SignerRecursion == true) {
      editRecursiveData["co_signer"] = true;
    }
    if (deleteRecursiveDocument) {
      deleteRecursiveDocument?.map((ele) => {
        dispatch(setdeleteDocument({ key: "", value: ele }));
      });
      dispatch(cleardeleteRecursiveDocument());
    }

    // if minor is edited then updated then sync his details with guardian
    if (!Object.keys(recursiveFormData).includes("guardian_of")) {
      let guardianIds = getGuardiansId(saveData, recursiveFormData.uid);
      for (const gaurdianId of guardianIds) {
        let guardianInfo = saveData.find(
          (guardian) => guardian.uid === gaurdianId
        );
        let guardianIndex = saveData.indexOf(guardianInfo);
        let guardianInfoShow = structuredClone(showData[guardianIndex]);
        guardianInfoShow.guardian_of = guardianInfo.guardian_of
          .map((guardianId) => {
            return guardianId === recursiveFormData.uid
              ? recursiveFormData[guardianKey]
              : saveData.find((app) => app.uid === guardianId)[guardianKey];
          })
          .join(",");
        dispatch(
          setEditShowData({ editIndex: guardianIndex, data: guardianInfoShow })
        );
      }
    }
    const saveRecursiveData = {
      ...editRecursiveData,
    };
    if (Object.keys(recursiveFormData).includes("guardian_of")) {
      const dependents = getDependentsId(saveData, guardianKey);
      saveRecursiveData["guardian_of"] = getDependentsNames(
        dependents,
        saveData,
        guardianKey
      ).join(",");
      editRecursiveData.guardian_of = recursiveFormData.guardian_of;
    }
    editRecursiveData.uid = recursiveFormData.uid;
    editRecursiveData.majority = recursiveFormData.majority;
    dispatch(
      setEditShowData({ editIndex: editIndex, data: saveRecursiveData })
    );
    dispatch(
      setEditSaveData({ editIndex: editIndex, data: editRecursiveData })
    );
    dispatch(setIsEditRecursiveForm(false));
    dispatch(setShowRecursiveForm(false));
    dispatch(setShowAddMore(true));
    dispatch(setIsAssociatedWfDisabled(false));
    dispatch(setEditIndex(-1));
    dynamicFormScroll();
    dispatch(clearRecursiveFormData());
  };

  useEffect(() => {
    checkWindowWidth();
  }, []);

  useEffect(() => {
    dispatch(setMinLength(minLength));
    dispatch(setMaxLength(maxLength));
    let formattedFormFields = inputFields.filter(
      (item) => item.type != "toggle"
    );
    dispatch(setFormFields(formattedFormFields));
    // Reseting to default values when all data in saveData is removed
    dispatch(setCurrentFormType("applicant"));
    // dispatch(setAssociateRequired());
  }, []);

  useEffect(() => {
    dispatch(setIsEditRecursiveForm(false));
    dispatch(clearRecursiveFormData());
    dispatch(clearShowData());
    dispatch(clearSaveData());
    let formattedFormFields = inputFields.filter(
      (item) => item.type != "toggle"
    );
    dispatch(setFormFields(formattedFormFields));
    dispatch(setArrayName(recursiveName));
    dispatch(setGuardianKey(guardianKey));
    dispatch(setGuardianLabel(guardianLabel));
    dispatch(setMaxGuardianLimit(maxGuardianLimit))
    if (formData.selectedData[recursiveName]) {
      if (formData.selectedData[recursiveName] === true) {
        dispatch(setShowRecursiveForm(true));
        return;
      }
      dispatch(setShowDataPreview(true));
      dispatch(setShowRecursiveForm(false));
      formData.selectedData[recursiveName].map((item) => {
        dispatch(setShowData(item));
      });
      dispatch(setSaveData(formData.selectedData[recursiveName]));
      if (inputFields[0].type === "toggle") {
        dispatch(
          setRecursiveFormData({ key: inputFields[0].name, value: true })
        );
      }
    } else if (
      subworkFlowInfo &&
      subworkFlowInfo["source_data"] &&
      subworkFlowInfo?.source_data[recursiveName]
    ) {
      if (subworkFlowInfo?.source_data[recursiveName] === true) {
        dispatch(setShowRecursiveForm(true));
        return;
      }
      dispatch(setShowDataPreview(true));
      dispatch(setShowRecursiveForm(false));
      subworkFlowInfo?.source_data[recursiveName]?.map((item) => {
        dispatch(setShowData(item));
      });
      dispatch(setSaveData(subworkFlowInfo?.source_data[recursiveName]));
      if (inputFields[0].type === "toggle") {
        dispatch(
          setRecursiveFormData({ key: inputFields[0].name, value: true })
        );
      }
    }
    if (SignerRecursion == true && signaturePosition && triggerEsignRequest) {
      dispatch(
        setSignerParams({ key: "signature_position", value: signaturePosition })
      );
      dispatch(
        setSignerParams({
          key: "trigger_esign_request",
          value: triggerEsignRequest,
        })
      );
      if (signer_validation_name) {
        dispatch(
          setSignerParams({
            key: "signer_validation_name",
            value: signer_validation_name,
          })
        );
      }
    }
  }, [recursiveName]);

  // Mobile Responsivess - conditions - start

  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width < 640 && !isMobile) {
      setIsMobile(true);
    } else if (width > 640 && isMobile) {
      setIsMobile(false);
    }
  };

  window.addEventListener("resize", () => checkWindowWidth());

  // Mobile Responsivess - conditions - end

  return (
    <Row className="p-2 p-md-3 rounded-3 bg-theme-grey-2 border gy-2 m-1 my-lg-o mx-lg-0">
      {!dataPreview && (
        <>
          {inputFields &&
            inputFields?.map((item, index) => {
              //Displaying the recursive form
              return (
                <Fragment key={index}>
                  <DynamicForm
                    formErr={formErr}
                    setFormErr={setFormErr} // if (item.type == "toggle")
                    clearFieldError={clearFieldError}
                    setSelectedData={
                      item.type === "toggle"
                        ? Object.entries(subworkFlowInfo)?.length > 0
                          ? setSubworkFlowInfo
                          : setSelectedFormData
                        : setSelectedData
                    }
                    selectedData={
                      item.type === "toggle"
                        ? Object.entries(subworkFlowInfo)?.length > 0
                          ? subworkFlowInfo?.source_data
                          : selectedFormData
                        : selectedData
                    }
                    formButtons={recursiveActions}
                    recursiveFormButtons={recursiveActions}
                    formFields={item}
                    isRecursive={true}
                  />
                </Fragment>
              );
            })}
          <FormButton
            formButtons={recursiveActions}
            handleNext={handleNext}
            handleCancel={handleCancel}
            handleBack={handleBack}
            selectedData={selectedData}
            handleAddMore={handleAddMore}
            //Using this in validateAndSubmit function
            isRecursive={true}
            minLength={minLength}
            maxLength={maxLength}
            isMobile={isMobile}
          />
        </>
      )}

      {dataPreview && (
        <>
          <>
            <div className="px-2">
              <Label label={recursiveTitle} />
            </div>
            <GuardianRecursiveDataPreview
              recursiveRead={recursiveRead}
              recursiveTrigger={recursiveTrigger}
              data={showData}
              handleEditChange={handleEditChange}
            />
            {showRecursiveForm &&
              inputFields &&
              inputFields?.map((item, index) => {
                if (item.type == "toggle") return;
                return (
                  <Fragment key={index}>
                    <DynamicForm
                      formFields={item}
                      selectedData={recursiveFormData}
                      setSelectedData={setSelectedData}
                      formErr={formErr}
                      clearFieldError={clearFieldError}
                      isRecursive={true}
                    />
                  </Fragment>
                );
              })}
            <FormButton
              formButtons={recursiveActions}
              handleNext={handleNext}
              handleCancel={handleCancel}
              handleBack={handleBack}
              handleEdit={handleEdit}
              handleAddMore={handleAddMore}
              isRecursive={true}
              className="recursive_button"
              minLength={minLength}
              maxLength={maxLength}
              isMobile={isMobile}
            />
          </>
        </>
      )}
      <ToastContainer containerId={"Guardian"}/>
    </Row>
  );
};

export default GuardianRecursive;
